import Model from "./base/model";

class canhotoFile extends Model{
  resourceName() {
    return "canhoto_files";
  }

  fields() {
    return {
      path: "",
      name: "",
      order_id:"",
      nf_files: {jsonApi: "hasOne", type: "nf_files"},
      oficio_files: {jsonApi: "hasOne", type: "oficio_files"},
      created_at: "",
    }
  }
}

export default new canhotoFile();
